import bog from '../../utils/moreBog';
import logError from '../../utils/watchdog';

export class GwResponseError extends Error {
  constructor(message) {
    super(message);
    this.name = 'GwResponseError';
  }
}

export const handleGwData = res => {
  if (res) {
    if (res.success) {
      return res.data || null;
    }
    const { code, message } = res;
    bog.error(`GwResponseError: ${JSON.stringify(res)}`);
    logError({
      c: code,
      message,
    });
    throw new GwResponseError(res.message);
  }
  return null;
};

export const setPostBody = (data = {}) => ({ body: JSON.stringify(data) });

const generateURLParams = (data = {}) => {
  const params = new URLSearchParams();
  Object.keys(data).forEach(key => {
    params.set(key, data[key]);
  });
  return params;
};

export const setGetParams = data => generateURLParams(data).toString();

export const setLegacyPostBody = data => ({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  body: generateURLParams(data),
});

const createBaseActions = (type, ...argNames) => (...args) => {
  const action = { type };
  argNames.forEach((arg, index) => {
    action[argNames[index]] = args[index];
  });
  return action;
};

export default createBaseActions;
